"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ContactPreferences = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _head2 = _interopRequireDefault(require("lodash/head"));
var _fromPairs2 = _interopRequireDefault(require("lodash/fromPairs"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _get5 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _updateContactPreferences = require("../../validations/updateContactPreferences");
var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _Panel = _interopRequireDefault(require("angieslist-react-components/lib/Panel"));
var _ListGroup = _interopRequireDefault(require("angieslist-react-components/lib/ListGroup"));
var _ListGroupItem = _interopRequireDefault(require("angieslist-react-components/lib/ListGroupItem"));
var _ReduxForm = _interopRequireDefault(require("angieslist-react-components/lib/ReduxForm"));
var _reactRedux = require("react-redux");
var memberMgmtGatewayActions = _interopRequireWildcard(require("../../../actions/memberMgmtGatewayActions"));
var serviceProviderGatewayActions = _interopRequireWildcard(require("../../../actions/serviceProviderGatewayActions"));
var myAccountUIActions = _interopRequireWildcard(require("../../../actions/myAccountUIActions"));
var _reduxForm = require("redux-form");
var _contactPreferenceCopy = _interopRequireDefault(require("../contactPreferenceCopy"));
var _fixContactPrefLinks = require("../myAccount/fixContactPrefLinks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var pageHeader = 'Email & Phone Preferences';
var displayUnsubscribeSuccessMessage = function displayUnsubscribeSuccessMessage(preferenceName) {
  return /*#__PURE__*/_react["default"].createElement("span", null, "You have been unsubscribed from ", /*#__PURE__*/_react["default"].createElement("em", null, preferenceName));
};
var saveSuccessMessage = /*#__PURE__*/_react["default"].createElement("em", null, "Your preferences have been updated. It may take up to 5 days for this update to take effect");
var ContactPreferences = exports.ContactPreferences = /*#__PURE__*/function (_React$Component) {
  function ContactPreferences() {
    (0, _classCallCheck2["default"])(this, ContactPreferences);
    return _callSuper(this, ContactPreferences, arguments);
  }
  (0, _inherits2["default"])(ContactPreferences, _React$Component);
  return (0, _createClass2["default"])(ContactPreferences, [{
    key: "submit",
    value: function submit(_ref) {
      var email = _ref.email,
        serviceProviderId = _ref.serviceProviderId,
        values = _ref.values,
        appName = _ref.appName,
        apiToken = _ref.apiToken,
        saveUserContactPreferencesByEmail = _ref.saveUserContactPreferencesByEmail,
        saveAssociateContactPreferencesByEmail = _ref.saveAssociateContactPreferencesByEmail;
      var preferences = (0, _map2["default"])(values, function (value, k) {
        return {
          key: k,
          enabled: value
        };
      });
      var params = {
        email: email,
        apiToken: apiToken,
        preferences: preferences
      };
      if (appName === 'member-app') {
        saveUserContactPreferencesByEmail(params);
      } else {
        saveAssociateContactPreferencesByEmail(_objectSpread(_objectSpread({}, params), {}, {
          serviceProviderId: serviceProviderId
        }));
      }
    }
  }, {
    key: "resetSavedForm",
    value: function resetSavedForm(appName, resetSaveUserContactPreferencesByEmail, resetSaveAssociateContactPreferencesByEmail) {
      var resetAction = appName === 'member-app' ? resetSaveUserContactPreferencesByEmail : resetSaveAssociateContactPreferencesByEmail;
      resetAction();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        pristine = _this$props.pristine,
        invalid = _this$props.invalid,
        email = _this$props.email,
        serviceProviderId = _this$props.serviceProviderId,
        gateWay = _this$props.gateWay,
        apiToken = _this$props.apiToken,
        appName = _this$props.appName,
        handleSubmit = _this$props.handleSubmit,
        saveUserContactPreferencesByEmail = _this$props.saveUserContactPreferencesByEmail,
        saveAssociateContactPreferencesByEmail = _this$props.saveAssociateContactPreferencesByEmail,
        resetSaveUserContactPreferencesByEmail = _this$props.resetSaveUserContactPreferencesByEmail,
        resetSaveAssociateContactPreferencesByEmail = _this$props.resetSaveAssociateContactPreferencesByEmail;
      var _get2 = (0, _get5["default"])(gateWay, 'getContactPreferencesByEmail'),
        isContactPreferenceLoading = _get2.isLoading,
        getContactPreferencesError = _get2.error,
        contactPrefsResponse = _get2.response;
      var _get3 = (0, _get5["default"])(gateWay, 'saveContactPreferencesByEmail'),
        isSaveContactPreferencesLoading = _get3.isLoading,
        saveContactPreferencesError = _get3.error,
        saveContactPreferencesResponse = _get3.response;
      var _get4 = (0, _get5["default"])(gateWay, 'unsubscribeFromContactPreferenceByEmail'),
        unsubscribeContactPreferenceRequest = _get4.request,
        unsubscribeContactPreferenceError = _get4.error;
      var unsubscribedPreference = (0, _head2["default"])((0, _get5["default"])(unsubscribeContactPreferenceRequest, 'params.preferences', []));
      var contactPreferences = (0, _map2["default"])((0, _get5["default"])(contactPrefsResponse, 'preferences', []), function (pref) {
        return (0, _fixContactPrefLinks.fixContactPrefLinks)(pref, appName);
      }).filter(function (pref) {
        return pref.key !== 'marketing_sms';
      });
      var emailIsValid = (0, _updateContactPreferences.validateEmail)(email);
      var unsubscribedPrefType = null;
      if (unsubscribedPreference) {
        unsubscribedPrefType = (0, _find2["default"])(contactPreferences, function (p) {
          return p.key === unsubscribedPreference.key;
        });
      }
      var hasUnsubscribed = unsubscribedPrefType && !unsubscribeContactPreferenceError;
      var hasSavedChanges = saveContactPreferencesResponse && !saveContactPreferencesError;
      var saveButtonStyle = appName === 'office-app' ? 'primary-office' : 'primary';
      return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "h3"
      }, pageHeader), !emailIsValid || getContactPreferencesError ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        bsStyle: "danger"
      }, (0, _angieslistAppPlatform.getErrorMessage)(getContactPreferencesError || {})) : /*#__PURE__*/_react["default"].createElement("form", {
        name: "contact-preferences-unsubscribe",
        onSubmit: handleSubmit(function (values) {
          _this.submit({
            email: email,
            serviceProviderId: serviceProviderId,
            values: values,
            appName: appName,
            apiToken: apiToken,
            saveUserContactPreferencesByEmail: saveUserContactPreferencesByEmail,
            saveAssociateContactPreferencesByEmail: saveAssociateContactPreferencesByEmail
          });
        })
      }, unsubscribeContactPreferenceError || saveContactPreferencesError ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        bsStyle: "danger"
      }, (0, _angieslistAppPlatform.getErrorMessage)(unsubscribeContactPreferenceError || saveContactPreferencesError)) : null, hasUnsubscribed || hasSavedChanges ? hasUnsubscribed ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        bsStyle: "info",
        id: "preferences--unsubscribe"
      }, displayUnsubscribeSuccessMessage(unsubscribedPrefType.displayName)) : /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        bsStyle: "info",
        dismissAfter: 3000,
        onDismiss: function onDismiss() {
          _this.resetSavedForm(appName, resetSaveUserContactPreferencesByEmail, resetSaveAssociateContactPreferencesByEmail);
        }
      }, saveSuccessMessage) : null, /*#__PURE__*/_react["default"].createElement(_contactPreferenceCopy["default"], {
        email: email
      }), /*#__PURE__*/_react["default"].createElement(_ListGroup["default"], null, (0, _map2["default"])(contactPreferences, function (_ref2) {
        var key = _ref2.key,
          displayName = _ref2.displayName,
          description = _ref2.description,
          rank = _ref2.rank;
        return /*#__PURE__*/_react["default"].createElement(_ListGroupItem["default"], {
          key: rank
        }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
          name: key,
          type: "checkbox",
          id: "contact-preferences-form--checkbox-id".concat(rank),
          label: /*#__PURE__*/_react["default"].createElement("b", null, displayName)
        }), description);
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "contact-preferences-form--save-button",
        flat: true,
        bsStyle: saveButtonStyle,
        disabled: pristine || invalid || isContactPreferenceLoading,
        loading: isSaveContactPreferencesLoading,
        bsSize: "small",
        type: "submit"
      }, "Save"))))));
    }
  }]);
}(_react["default"].Component);
ContactPreferences.propTypes = {
  email: _propTypes["default"].string.isRequired,
  serviceProviderId: _propTypes["default"].number,
  gateWay: _propTypes["default"].object,
  apiToken: _propTypes["default"].string.isRequired,
  appName: _propTypes["default"].string.isRequired,
  saveUserContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  saveAssociateContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  resetSaveUserContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  resetSaveAssociateContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  // redux form
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired
};
var ContactPreferencesReduxForm = (0, _reduxForm.reduxForm)({
  form: 'contact-preferences-unsubscribe',
  enableReinitialize: true
})(ContactPreferences);
var _default = exports["default"] = (0, _compose["default"])((0, _reactRedux.connect)(function (state, props) {
  var isMemberApp = props.appName === 'member-app';
  var gateWay = isMemberApp ? props.memberManagementGateway : props.serviceProviderGateway;
  var getContactPreferences = (0, _get5["default"])(gateWay, 'getContactPreferencesByEmail.response.preferences', {});
  var keyValuesArray = (0, _map2["default"])(getContactPreferences, function (pref) {
    return [pref.key, pref.enabled];
  });
  var fieldValues = (0, _fromPairs2["default"])(keyValuesArray);
  return {
    initialValues: fieldValues,
    gateWay: gateWay
  };
}, _objectSpread(_objectSpread(_objectSpread({}, memberMgmtGatewayActions), serviceProviderGatewayActions), myAccountUIActions)), _pure["default"])(ContactPreferencesReduxForm);


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/contactPreferences/contactPreferences.js
// module id = 4304
// module chunks = 9